import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9089030e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "solicitud"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Participar ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "15",
    cy: "15",
    r: "15",
    fill: "#006C90"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z",
    fill: "white"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body info" }
const _hoisted_9 = { class: "fv-row mb-7" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder title-body" }, "Rut del Proveedor", -1))
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "fv-row mb-7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder title-body" }, "Nombre:", -1))
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "fv-row mb-7" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder title-body" }, "Email:", -1))
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "fv-row mb-7" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder title-body" }, "Teléfono", -1))
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-md btn-melon w-100 mb-5"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Quiero participar ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Por favor espere... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  type: "button",
                  class: "closeModel",
                  "data-dismiss": "modal",
                  "aria-label": "Cerrar",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelarSolicitud()))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Form, {
                  class: "form w-100 col-12",
                  novalidate: "novalidate",
                  onSubmit: _ctx.onSubmit,
                  "validation-schema": _ctx.registration
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg",
                        type: "text",
                        placeholder: "",
                        name: "rut",
                        onKeyup: _ctx.formatRut,
                        modelValue: _ctx.form.rut,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.rut) = $event)),
                        autocomplete: "off"
                      }, null, 8, ["onKeyup", "modelValue"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_ErrorMessage, { name: "rut" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg",
                        type: "text",
                        placeholder: "",
                        name: "nombreProveedor",
                        autocomplete: "off"
                      }),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "nombreProveedor" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg",
                        type: "email",
                        placeholder: "",
                        name: "correo",
                        autocomplete: "off"
                      }),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_ErrorMessage, { name: "correo" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg",
                        type: "phone",
                        placeholder: "",
                        name: "telefono",
                        autocomplete: "off",
                        onKeydown: _ctx.validarNumero
                      }, null, 8, ["onKeydown"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, { name: "telefono" })
                        ])
                      ])
                    ]),
                    _createElementVNode("button", _hoisted_25, _hoisted_28, 512)
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}